import { pricingPlans } from "@/mocks/homeContent";
import { useReveal } from "@/hooks/useReveal";

export default function PricingPlans() {
  const { ref, visible } = useReveal<HTMLDivElement>(0.1);

  return (
    <section id="plans" className="w-full bg-background-50 py-14 md:py-20">
      <div
        ref={ref}
        className={`mx-auto w-full px-4 md:px-8 ${visible ? "reveal is-visible" : "reveal"}`}
      >
        <div className="mx-auto max-w-2xl text-center">
          <div className="flex items-center justify-center gap-2">
            <span className="h-4 w-1 rounded-full bg-accent-500" />
            <span className="text-xs font-medium tracking-[0.18em] text-secondary-600">
              MEMBERSHIP PLANS
            </span>
          </div>
          <h2 className="font-heading mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">
            选择你的开通方式
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            一次开通即可解锁黑料福利专属与内部内容，提前看料、看完整版，付费资源一网打尽。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-3 lg:gap-6">
          {pricingPlans.map((plan) => (
            <div
              key={plan.id}
              className={`relative flex flex-col rounded-lg border p-6 md:p-7 ${
                plan.highlight
                  ? "border-primary-400 bg-primary-50"
                  : "border-background-200 bg-background-50"
              }`}
            >
              {plan.badge && (
                <span
                  className={`absolute -top-3 left-6 rounded-full px-3 py-1 text-xs font-medium ${
                    plan.highlight
                      ? "bg-primary-500 text-background-50"
                      : "bg-accent-100 text-accent-800"
                  }`}
                >
                  {plan.badge}
                </span>
              )}

              <h3 className="font-heading text-lg font-semibold text-foreground-950">{plan.name}</h3>
              <p className="mt-2 text-sm text-foreground-600">{plan.desc}</p>

              <div className="mt-5 flex items-end gap-2">
                <span className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
                  {plan.price === "0" ? "免费" : `¥${plan.price}`}
                </span>
                <span className="pb-1 text-sm text-foreground-500">/ {plan.period}</span>
              </div>

              <ul className="mt-6 space-y-3">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-2.5 text-sm text-foreground-700">
                    <span
                      className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${
                        plan.highlight
                          ? "bg-primary-500 text-background-50"
                          : "bg-secondary-100 text-secondary-800"
                      }`}
                    >
                      <i className="ri-check-line text-xs" />
                    </span>
                    {feature}
                  </li>
                ))}
              </ul>

              <button
                type="button"
                className={`mt-7 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md px-4 py-3 text-sm font-medium transition-colors ${
                  plan.highlight
                    ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                    : "border border-secondary-300 text-foreground-800 hover:border-primary-400 hover:text-primary-600"
                }`}
              >
                {plan.cta}
                <i className="ri-arrow-right-line" />
              </button>
            </div>
          ))}
        </div>

        <p className="mt-6 text-center text-xs text-foreground-500">
          页面为展示效果，开通与支付能力将在后续接入
        </p>
      </div>
    </section>
  );
}